module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    " + _vm._s(_vm.city.name) + "\n    "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'city-edit',
        params: {
          city_id: _vm.city.id
        }
      }
    }
  }, [_vm._v("Редактировать город")])], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'cities'
      }
    }
  }, [_vm._v("← Назад к Городам")])], 1), _vm._v(" "), (false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Название")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.city.name))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('router-view', {
    attrs: {
      "city-id": _vm.city.id
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74f99945","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/city/CityDetails.vue
// module id = 672
// module chunks = 0